import { FC, ReactNode } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import SimpleLoader from "./SimpleLoader";
import { InModalContext } from "./InModalContext";

type Props = {
  show: boolean;
  title: string;
  onClose: () => void;
  onSubmit?: () => void;
  isSubmitting?: boolean;
  submitText?: string;
  children: ReactNode;
  width?: string;
  showLoader?: boolean;
  loadingText?: string;
  cancelText?: string;
  hideSubmitButton?: boolean;
  showCancelButton?: boolean
};

const AppModal: FC<Props> = ({
  show,
  title,
  onClose,
  onSubmit,
  isSubmitting = false,
  submitText = "Save",
  children,
  width = "1200px",
  showLoader = false,
  loadingText = "Loading...",
  cancelText = "Cancel",
  hideSubmitButton = false,
  showCancelButton = true
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName={`modal-dialog modal-dialog-xl modal-dialog-centered mw-${width}`}
    >
      {showLoader && <SimpleLoader className={"bg-black-30 z-2"} text={loadingText} />}
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <InModalContext.Provider value={true}>{children}</InModalContext.Provider>
      </Modal.Body>

      <Modal.Footer>
        {showCancelButton && <Button variant="light" onClick={onClose}>
          {cancelText}
        </Button>}

        {onSubmit && !hideSubmitButton && (
          <Button variant="primary" onClick={onSubmit} disabled={isSubmitting}>
            {submitText} {isSubmitting && <Spinner animation="border" size="sm" />}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AppModal;